<template>
  <div class="volunteeringDetail page-content pb-6">
    <v-parallax
      src="@/assets/header-parallax-2.jpg"
      height="200"
      class="page-header"
    >
      <v-container
        ><h1>
          {{ $t("texts.donationOf") }} {{ data.programName }}
        </h1></v-container
      >
    </v-parallax>

    <v-container>
      <v-row class="applyBtns">
        <v-col class="text-left">
          <v-btn class="primary" @click="$router.back()">
            <v-icon left small>mdi-triangle mdi-rotate-270</v-icon>

            {{ $t("texts.goback") }}
          </v-btn>
        </v-col>

        <v-col class="text-right" v-if="canDonate">
          <v-btn class="primary" @click="applyDialog = true"
            >{{ $t("texts.makeDonation") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-card
        color="grey lighten-5"
        style="max-width: 85%"
        elevation="4"
        class="mx-auto"
      >
        <donation-detail-card :data="data"></donation-detail-card>
      </v-card>
    </v-container>

    <!-- Donation Info Item Dialog -->
    <v-dialog v-model="applyDialog" persistent max-width="1100px">
      <v-card>
        <v-container class="pa-4">
          <div class="d-flex flex-column-reverse flex-sm-row mx-2 mb-4">
            <div>
              <h4>{{ $t("texts.makeDonation") }} - {{ data.programName }}</h4>
            </div>
            <div class="ml-auto">
              <v-btn icon color="accent" @click="applyDialog = false">
                <v-icon x-large>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-form @submit.prevent="makeDonation" class="mx-4">
            <v-row>
              <v-col cols="12" lg="6" class="form-layout">
                <a-text-field
                  v-model="$v.formInputName.$model"
                  :validator="$v.formInputName"
                  :label="
                    $t('texts.completeName') + '\u00A0' + $t('texts.required')
                  "
                />
                <a-text-field
                  v-model="$v.formInputNIFVAT.$model"
                  :validator="$v.formInputNIFVAT"
                  :label="$t('texts.NIFVAT') + '\u00A0' + $t('texts.required')"
                />
                <p class="ml-3">
                  {{
                    $t("texts.IPSRelation") + "\u00A0" + $t("texts.required")
                  }}
                </p>
                <v-radio-group
                  v-model="$v.formInputIpsRelation.$model"
                  :validator="$v.formInputIpsRelation"
                  mandatory
                  hide-details="auto"
                >
                  <v-radio :label="$t('texts.student')" value="1"></v-radio>
                  <v-radio
                    :label="$t('texts.graduateAlumni')"
                    value="2"
                  ></v-radio>
                  <v-radio
                    :label="$t('texts.lecturerTeacher')"
                    value="3"
                  ></v-radio>
                  <v-radio
                    :label="$t('texts.nonTeachingStaff')"
                    value="4"
                  ></v-radio>
                  <v-radio
                    :label="$t('texts.scholarshipHolderResearcherFellowship')"
                    value="5"
                  ></v-radio>
                  <v-radio :label="$t('texts.IPSPartner')" value="6"></v-radio>
                  <v-radio :label="$t('texts.other')" value="7"></v-radio>
                </v-radio-group>
                <a-text-field
                  v-model="formInputIpsRelationOther"
                  v-show="
                    formInputIpsRelation && formInputIpsRelation.includes(7)
                  "
                  class="mt-3"
                  :label="$t('texts.other')"
                />
              </v-col>
              <v-col cols="12" lg="6" class="form-layout">
                <a-text-field
                  v-model="$v.formInputAddress.$model"
                  :validator="$v.formInputAddress"
                  :label="$t('texts.address') + '\u00A0' + $t('texts.required')"
                />
                <a-text-field
                  v-model="$v.formInputEmail.$model"
                  :validator="$v.formInputEmail"
                  type="email"
                  :label="$t('texts.email') + '\u00A0' + $t('texts.required')"
                />
                <a-text-field
                  v-model="$v.formInputAmount.$model"
                  :validator="$v.formInputAmount"
                  :label="$t('texts.Amount') + '\u00A0' + $t('texts.required')"
                />
                <v-file-input
                  v-model="formInputBankTransfer"
                  :label="
                    $t('texts.bankTransferConfirmation') +
                      '\u00A0' +
                      $t('texts.required')
                  "
                  hide-details="auto"
                ></v-file-input>
                <v-file-input
                  v-model="formInputLogo"
                  accept="image/jpeg"
                  show-size
                  :label="$t('texts.logoForDisclosure')"
                  hide-details="auto"
                ></v-file-input>
                <div>
                  <p class="ml-3">
                    {{
                      $t("texts.PublicListIdentification") +
                        "\u00A0" +
                        $t("texts.required")
                    }}
                  </p>
                  <v-radio-group
                    v-model="formInputPublicListIdentification"
                    mandatory
                    hide-details="auto"
                    class="ml-3"
                  >
                    <v-radio :label="$t('texts.yes')" value="1"></v-radio>
                    <v-radio :label="$t('texts.no')" value="0"></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p>
                  {{
                    $t("texts.rgpdauthorization") +
                      "\u00A0" +
                      $t("texts.required")
                  }}
                </p>
                <div class="d-flex">
                  <a-checkbox v-model="formInputAgreement"></a-checkbox>
                  {{ $t("texts.Agreement", { program: data.programName }) }}
                </div>
              </v-col>
            </v-row>

            <div
              class="d-flex flex-column-reverse flex-sm-row align-center justify-end"
            >
              <div class="mt-2 mb-2 mt-sm-4 mb-sm-2 mr-sm-4">
                <v-btn large color="primary--text" @click="applyDialog = false">
                  {{ $t("texts.cancel") }}
                </v-btn>
              </div>
              <div class="mt-4 mb-2 mt-sm-4 mb-sm-2 ml-sm-4">
                <v-btn large color="primary" type="submit">{{
                  $t("texts.submit")
                }}</v-btn>
              </div>
            </div>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- !Donation Info Item Dialog -->
  </div>
</template>
<style scope lang="sass">
.applyBtns
  margin-left:120px
  margin-right:120px
  margin-bottom: 40px
</style>

<script>
// @ is an alias to /src
import AppError from "@/utils/AppError.js";
import ATextField from "@/components/fields/ATextField.vue";
import DonationDetailCard from "@/components/DonationDetailCard.vue";
import ACheckbox from "@/components/fields/ACheckbox.vue";

import { validationMixin } from "vuelidate";
import { email } from "vuelidate/lib/validators";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "volunteeringDetail",

  components: {
    ATextField,
    DonationDetailCard,
    ACheckbox
  },

  mounted: function() {
    this.loadData();
  },

  mixins: [validationMixin],

  validations: {
    formInputName: { required, minLength: minLength(5) },
    formInputNIFVAT: { required },
    formInputAddress: { required },
    formInputEmail: { required, email },
    formInputIpsRelation: { required },
    formInputAmount: { required },
    formInputPublicListIdentification: { required }
  },

  data() {
    return {
      data: {},

      applyDialog: false,

      formInputName: null,
      formInputNIFVAT: null,
      formInputAddress: null,
      formInputEmail: null,
      formInputIpsRelation: null,
      formInputIpsRelationOther: null,
      formInputAmount: null,
      formInputBankTransfer: null,
      formInputLogo: null,
      formInputPublicListIdentification: null,
      formInputAgreement: null
    };
  },
  created() {
    this.donationId = this.$route.params.donationId;
  },

  props: {
    donationId: String
  },

  methods: {
    /**
     * Get donation details.
     * @public
     */
    loadData() {
      // Load form data
      this.$store.dispatch("Util/startLoading");
      let url = this.$config.api.route.donationDetail;
      url = url.replace(":id", this.donationId);
      this.$api({
        url: url,
        method: "GET"
      })
        .then(resp => {
          this.data = resp.data;
        })
        .catch(() => {
          AppError.handle(new AppError("LOAD_DATA_UNKNOWN"));
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    },

    /**
     * Make donation.
     * @public
     */
    makeDonation() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      if (!this.formInputBankTransfer) {
        this.$store.dispatch("Alert/showError", this.$t("errors.UPLOAD_PROOF"));
        return;
      }

      if (!this.formInputAgreement) {
        this.$store.dispatch(
          "Alert/showError",
          this.$t("errors.ACCEPT_AGREEMENT")
        );
        return;
      }

      this.$store.dispatch("Util/startLoading");
      let url = this.$config.api.route.makeDonation;
      url = url.replace(":id", this.donationId);

      const formData = new FormData();
      formData.append("fullName", this.formInputName);
      formData.append("nifVat", this.formInputNIFVAT);
      formData.append("address", this.formInputAddress);
      formData.append("email", this.formInputEmail);
      formData.append("ipsRelation", this.formInputIpsRelation);
      formData.append("ipsRelationOther", this.formInputIpsRelationOther);
      formData.append("amount", this.formInputAmount);
      formData.append("proof", this.formInputBankTransfer);
      formData.append("identity", this.formInputPublicListIdentification);
      if (this.formInputLogo) {
        formData.append("logo", this.formInputLogo);
      }

      this.$api({
        url: url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data"
        },
        method: "POST"
      })
        .then(() => {
          this.applyDialog = false;
          this.loadData();

          this.$store.dispatch(
            "Alert/showSuccess",
            this.$t("texts.successDonate")
          );

          // Reset fields and validations
          this.formInputName = null;
          this.formInputNIFVAT = null;
          this.formInputAddress = null;
          this.formInputEmail = null;
          this.formInputIpsRelation = null;
          this.formInputAmount = null;
          this.formInputIpsRelationOther = null;
          this.formInputBankTransfer = null;
          this.formInputLogo = null;
          this.formInputPublicListIdentification = null;
          this.formInputAgreement = null;
          this.$v.formInputName.$reset();
          this.$v.formInputNIFVAT.$reset();
          this.$v.formInputAddress.$reset();
          this.$v.formInputEmail.$reset();
          this.$v.formInputIpsRelation.$reset();
          this.$v.formInputAmount.$reset();
          this.$v.formInputPublicListIdentification.$reset();
        })
        .catch(err => {
          AppError.handle(err);
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    }
  },

  computed: {
    /**
     * Check if donation is monetary.
     */
    canDonate() {
      if (
        (this.data.type[0] === 1 &&
          new Date(this.data.dates.realizationStart) <= new Date()) ||
        (this.data.type[1] === 1 &&
          new Date(this.data.dates.realizationStart) <= new Date())
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
